/* eslint-disable react-hooks/rules-of-hooks */
import { Box, Grid } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router-dom';

import ExhibitionItem from 'commons/Exhibition/ExhibitionItem';
import Loading from 'commons/Loading';
import PaginationCustom from 'commons/PaginationCustom';
import Text from 'commons/Text';
import API from 'configs/API';
import usePagination from 'hooks/usePagination';
import { useQueryParameters } from 'utils/utils';

import TabArtworkHeader from '../TabArtworkHeader';
import useStyles from './styles';

const GalleryExhibition = ({ isOwner, isPublicShare = false, userUuid }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const query = useQueryParameters();
  const searchValue = query.get('search');

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const objectParamsFromSearchParams = Object.fromEntries(searchParams);
  const params = {
    ...objectParamsFromSearchParams,
  };

  if (isPublicShare) {
    params.user_uuid = userUuid;
  } else {
    params.user_uuid = id;
  }

  let listExhibition = [];
  let page = 1;
  let totalPage = 1;

  let onPageChange = () => {};

  const { data, isPending } = useQuery({
    queryKey: [API.ARTWORK.EXHIBITION, params],
  });
  const {
    page: _page,
    totalPage: _totalPage,
    onPageChange: _onPageChange,
  } = usePagination(data?.count, data?.page_size);
  page = _page;
  totalPage = _totalPage;
  onPageChange = _onPageChange;
  listExhibition = data?.results;

  if (isPending) {
    return <Loading />;
  }

  return (
    <Box sx={{ mt: 3 }}>
      <TabArtworkHeader
        placeholder={t('search_by_exhibition_name')}
        isOwner={isOwner}
      />

      <Box sx={{ pt: 3 }}>
        <Grid
          container
          spacing={5}
        >
          {listExhibition?.length > 0
            ? listExhibition.map((exhibition, index) => (
                // eslint-disable-next-line react/jsx-indent
                <Grid
                  key={index}
                  item
                  xs={12}
                  lg={3}
                >
                  <ExhibitionItem
                    exhibition={exhibition}
                    isOwner={isOwner}
                  />
                </Grid>
              ))
            : null}
        </Grid>

        {searchValue && listExhibition?.length === 0 && (
          <div className={classes.wrapTextNoResult}>
            <Text>{t('no_results_that_match_your_search')}</Text>
            <Text>{t('please_try_adjust_your_keywords')}</Text>
          </div>
        )}
      </Box>

      {!!totalPage && (
        <PaginationCustom
          paginationStyle={classes.pagination}
          count={totalPage}
          page={page}
          onChange={onPageChange}
        />
      )}
    </Box>
  );
};

export default GalleryExhibition;
